export default Object.freeze({
  Block: 1,
  Mask: 2,
  Warn: 3,
});
